<template>
  <div class="rp-messenger-help-and-support-scenario-content">
    <OrderItem
      v-if="orderHasData"
      class="rp-messenger-order-head-card"
      :orderData="selectedOrderData"
      :showTopHeaderOnly="true"
      :actionsList="[]"
    />
    <div class="rp-messenger-help-and-support-scenario-content__wrapper">
      <div class="rp-messenger-help-and-support-scenario-content__wrapper-inner">
        <template v-if="isExternalHelpdesk && formSubmitted">
          <ExternalHelpdesk
              :status="submittingPrechatFormData"
              @go-home="$emit('switchToHomeScreen', {})"
            />
        </template>
        <template v-else>
          <div class="rp-messenger-help-and-support-scenario">
          <ScenarioBackButton />
          <span class="rp-messenger-help-and-support-scenario-header">{{scenarioName}}</span>
          <div class="rp-messenger-help-and-support-response-text" v-if="!moveToPrechatScreen && formattedScenarioDesc" v-linkified v-html="formattedScenarioDesc"></div>
          <div v-if="moveToPrechatScreen">
            <div class="rp-messenger-help-and-support-response-text suggestion-text">{{ $t('sentences.provideBelowDetails') }}</div>
            <PreChatForm
              @submit="handlePreChatAndStartChatClick"
              :showAllDataTypes="true"
              :formHeaderLabel="$t('customerJourneyPreChatForm.heading')"
              class="animated fast fadeInRight"
              :formConfiguration="formConfiguration"
              :submitButtonlabel="$t('customerJourneyPreChatForm.proceed')"
              :userProperties="userProperties"
            />
            <VPadding :unit="0.4" />
          </div>
          </div>
          <template v-if="!moveToPrechatScreen">
            <div class="rp-scenario-cta-buttons" v-if="ctaList.length > 0">
              <div
                class="rp-scenario-content-ctaButtons"
                v-for="(ctaButton, index) in ctaList"
                :key="index"
              >
                <el-button
                  :style="{color: activeColor, borderColor: activeColor}"
                  @click="handleCtaClick(ctaButton)"
                  plain
                  class="uppercase-text"
                  :disabled="ctaButton.disabled"
                >
                  <span class="scenario-button-text">{{ctaButton.buttonText}}</span>
                </el-button>
              </div>
            </div>
            <div class="rp-scenario-button-suggestion-text" v-if="defaultActionType === 'ASK_FOR_RATING'" > {{$t('customerJourneyPreChatForm.canWeHelpWithAnythingElse')}} </div>
            <div class="rp-scenario-buttons" :class="{ 'ask-for-rating' : defaultActionType === 'ASK_FOR_RATING' }">
              <el-button
                :style="{color: defaultActionType !== 'ASK_FOR_RATING' ? activeColor : '#4d4d4d', borderColor: defaultActionType !== 'ASK_FOR_RATING' ? activeColor : '#DCDFE6', background: defaultActionType === 'ASK_FOR_RATING' ? '#ededed': 'inherit'}"
                @click="handleStartChatClick(defaultActionData.primaryCTAConfig.action)"
                plain
                class="uppercase-text"
              >
                <span class="scenario-button-text">{{defaultActionData.primaryCTAConfig.title}}</span>
              </el-button>
              <el-button
                v-if="defaultActionType === 'ASK_FOR_RATING'"
                :style="{color: defaultActionType !== 'ASK_FOR_RATING' ? activeColor : '#4d4d4d', borderColor: defaultActionType !== 'ASK_FOR_RATING' ? activeColor : '#DCDFE6', background: defaultActionType === 'ASK_FOR_RATING' ? '#ededed': 'inherit'}"
                @click="handleStartChatClick(defaultActionData.secondaryCTAConfig.action)"
                plain
                class="uppercase-text"
              >
                <span class="scenario-button-text">{{defaultActionData.secondaryCTAConfig.title}}</span>
              </el-button>
              <el-button
                v-else
                @click="handleStartChatClick(defaultActionData.secondaryCTAConfig.action)"
                type="text"
                class="rp-scneario-text-button"
              >
                <span class="scenario-button-text">{{defaultActionData.secondaryCTAConfig.title}}</span>
              </el-button>
              
              
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import PreChatForm from "./../../TextMessage/PreChatForm";
import { parsePropertyTagsV2, formatTheValue, formattedOrderDataV2 } from './../../../constants';
import ExternalHelpdesk from './../../ExternalHelpdesk';
import defaultActionMixin from './defaultActionMixin';
export default {
  mixins: [ defaultActionMixin ],
  data() {
    return {
      moveToPrechatScreen: false,
      formSubmitted: false,
    };
  },
  mounted() {
    this.$emit('scenarioEvent', { status: 1 })
  },
  components: {
    PreChatForm,
    ExternalHelpdesk
  },
  props: {
    scenarioName: {
      type: String,
      default: ""
    },
    submittingPrechatFormData: {
      type: String,
      default: "Loading",
    },
    responseText: {
      type: String,
      default: ""
    },
    ctaList: {
      type: Array
    },
    activeColor: {
      type: String
    },
    selectedOrderData: {
      type: Object,
      required: false
    },
    showStartChat: {
      type: Boolean,
      required: true
    },
    isCollectUserInputEnabled: {
      type: Boolean,
      required: true
    },
    chatUserInputs: {
      type: Array,
      required: true
    },
    properties: {
        type: Object,
        required: true
    },
    customerProperties: {
        type: Object,
        required: true
    },
    defaultActionType: {
      type: String,
      default: 'CONTACT_SUPPORT'
    },
    isExternalHelpdesk: {
      type: Boolean,
      default: false,
    },
    blockType: {
      type: String,
      default: 'HELPANDSUPPORT'
    }
  },
  methods: {

    handleCtaClick(ctaButton) {
      this.$emit('ctaButtonClick', ctaButton)
      this.$emit('scenarioEvent', { status: 2 })
    },
    async handlePreChatAndStartChatClick(event) {
      if(!this.isExternalHelpdesk){
        this.$emit("handleChatClick", this.scenarioName, null, event);
      } else {
        let eventData = event;
        if(this.orderHasData) 
          eventData.order = formattedOrderDataV2({
            selectedProucts: [],
            quantities: {},
            orderInfo: this.selectedOrderData
          })
        this.$emit("handleScenarioPreChatFormSubmit", eventData);
      }
      this.formSubmitted = true;
      this.$emit('scenarioEvent', { status: 3 })
    },
    async handleStartChatClick(action) {
      if(action === 'ATTEMPT_TO_CLOSE') {
        this.$emit('scenarioEvent', { status: 2 })
        this.$emit('switchToHomeScreen', {})
        return;
      }
      if(action === 'ASK_FOR_RATING') {
        //go to 3rd screen level breadcrumb if order scenario
        this.$emit('scenarioEvent', { status: 2 })
        if(this.blockType === 'HELPANDSUPPORT') {
          this.$emit('moveToScenario', { scenarioId: 'HELP_AND_SUPPORT'})
        } else {
          this.$emit('moveToScenario', { scenarioId: 'HELP_AND_SUPPORT_ORDER'})
        }
        return
      }
      if(action === 'ASK_FOR_RATING_NO') {
        //go to 1st screen level breadcrumb
        //clsoe the messenger
        this.$emit('scenarioEvent', { status: 4 })
        this.$emit('switchToHomeScreen', { closeMessenger: true })
        return
      }
      if (this.isTherePreChatForm) {
        this.moveToPrechatScreen = true;
      } else {
        this.$emit("handleChatClick", this.scenarioName, null),
        this.$emit('scenarioEvent', { status: 3 })
      }
    }
  },

  computed: {
    orderHasData() {
      return this.selectedOrderData &&
        Object.keys(this.selectedOrderData).length
        ? true
        : false;
    },
    userProperties() {
      const { properties, customerProperties } = this;
      return {...properties, ...customerProperties };
    },
    formattedScenarioDesc() {
      return parsePropertyTagsV2(this.responseText, (propName, type, propertyCategory) => {
          const { userProperties, selectedOrderData } = this;
          let propertiesDB = userProperties;
          if(propertyCategory === 'order'){
            propertiesDB = selectedOrderData || {}
          }
          if (propertiesDB) {
            if (propName in propertiesDB) {
              return formatTheValue(propertiesDB[propName], type);
            }
          }
          return ''
      }) 
    },    
    isTherePreChatForm() {
      if(this.isCollectUserInputEnabled && this.chatUserInputs.length > 0) return true
      if(this.isExternalHelpdesk) return true;
      return false;
    },
    formConfiguration() {
      const conf = {
        formType: "customerJourney",
        fields: []
      };
      if (this.isCollectUserInputEnabled) {
        if (!this.chatUserInputs || !this.chatUserInputs.length > 0)
          return conf;
        const { chatUserInputs } = this;
        chatUserInputs.forEach(inputField => {
          inputField.value = "";
          conf.fields.push(inputField);
        });
      }
      if(this.isExternalHelpdesk){
        if(!this.userProperties.email) {
          if(!conf.fields.find(({ propertyName }) => propertyName === 'email' )){
            conf.fields.push({
              groupName: 'People Data',
              propertyName: 'email',
              displayName: 'Email',
              type: "text",
              required: true,
              value: '',
          })
          }
        }
        conf.fields.push({
          groupName: 'Conversation Data',
          propertyName: 'customerMessageForExternalHelpdesk',
          displayName: 'Your message',
          type: "multiline",
          required: true,
          value: '',
          placeholder: false,
        })
      }
      return conf;
    },

  }
};
</script>

<style lang="scss" scoped>
.rp-messenger-help-and-support-scenario-content {
  margin: 16px;
  width: calc(100% - 32px);
  border-radius: 5px;
  background: #fff;
  height: unset;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1),
    inset 0 2px 0 0 rgba(220, 219, 236, 0);
  align-items: stretch;

  .rp-messenger-help-and-support-scenario-content__wrapper {
    padding: 20px;
    padding-bottom: 2rem;
    @include for-size(tablet-landscape-up){
      padding: 30px;
    }
    @include for-size(desktop-up){
      padding: 20px 60px;
    }
    .rp-messenger-help-and-support-scenario-content__wrapper-inner {
        @include for-size(tablet-landscape-up){
          width: 500px;
          max-width: 100%;
          margin: 0 auto;
        }
        @include for-size(desktop-up){
          width: 800px;
          max-width: 100%;
          margin: 0 auto;
        }
    }
  }
  .rp-scenario-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px 0px 0px 0px;
    &.ask-for-rating {
      flex-direction: row;
      .el-button + .el-button {
        margin-left: 20px;
      }
    }
    .scenario-button-text {
      font-weight: 500;
    }
    .rp-scenario-content-ctaButtons {
      display: flex;
      flex-direction: column;
    }
    .ctaButton {
      font-weight: 400;
    }

  button {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      line-height: 22px;
      @include for-size(desktop-up){
        font-size: 16px;
      }
  }
  }
  .rp-scenario-cta-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;

    .scenario-button-text {
      font-weight: 500;
    }
    .rp-scenario-content-ctaButtons {
      display: flex;
      flex-direction: column;
      padding-top: 12px;
      
      button {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          line-height: 22px;
          width: 360px;
          max-width: 100%;
          @include for-size(desktop-up){
            font-size: 16px;
          }
      }
    }
    .ctaButton {
      font-weight: 400;
    }
  }
  .rp-messenger-help-and-support-scenario {
    margin-bottom: 12px;
    .rp-messenger-help-and-support-scenario-header {
      font-size: 24px;
      color: $blackColor;
      word-break: break-word;
      font-weight: 500;
      @include for-size(desktop-up){
        font-size: 28px;
      }
      line-height: 1.3
    }
  }
}
</style>
